import cancelIcon from 'assets/images/cancel.svg'
import { Button, Container, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import BaseModal from './BaseModal'

export default function CancelProfileModal({
	show,
	onHide,
	title,
	otherProps,
	isLoading = false,
	onClick,
}) {
	const { t } = useTranslation()

	return (
		<BaseModal show={show} onHide={onHide} {...otherProps}>
			<Container className="baseinput-container modal-createroom" fluid>
				<Modal.Header>
					<img src={cancelIcon} alt="cancel" style={{ height: '70px' }} />
				</Modal.Header>
				<Modal.Body>
					<p
						className="text-center"
						style={{
							fontWeight: 500,
							fontSize: '17px',
							lineHeight: '24px',
							color: '#B1B5C3',
						}}
					>
						{title}
					</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="dark" onClick={onHide}>
						{t('modal.btn.no')}
					</Button>
					<Button disabled={isLoading} variant="secondary" onClick={onClick}>
						{t('modal.btn.yes')}
					</Button>
				</Modal.Footer>
			</Container>
		</BaseModal>
	)
}
